import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@mui/material';

/**
 * Small reusable confirm dialog. Driven by a `open` flag; calls onConfirm/onClose.
 * Used for "this case is being handled by {name} — take over?" prompts.
 * `confirmDelaySeconds` locks the confirm button for that long after opening, so a
 * serious action can't be confirmed by reflex (default 0 = no lock).
 */
export default function ConfirmDialog({
  open,
  title = 'ยืนยัน',
  message,
  confirmText = 'ยืนยัน',
  cancelText = 'ยกเลิก',
  confirmColor = 'warning',
  confirmDelaySeconds = 0,
  onConfirm,
  onClose,
}) {
  const [secondsLeft, setSecondsLeft] = useState(0);

  useEffect(() => {
    if (!open || confirmDelaySeconds <= 0) {
      setSecondsLeft(0);
      return undefined;
    }
    setSecondsLeft(confirmDelaySeconds);
    const timer = setInterval(() => {
      setSecondsLeft((s) => {
        if (s <= 1) {
          clearInterval(timer);
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [open, confirmDelaySeconds]);

  return (
    <Dialog open={!!open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ px: 3, pt: 2.5 }}>{title}</DialogTitle>
      <DialogContent sx={{ px: 3 }}>
        {/* break-word so long URLs wrap within the padding instead of crowding the right edge */}
        <DialogContentText sx={{ whiteSpace: 'pre-line', wordBreak: 'break-word' }}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <Button onClick={onClose} color="inherit">{cancelText}</Button>
        <Button onClick={onConfirm} color={confirmColor} variant="contained" autoFocus disabled={secondsLeft > 0}>
          {secondsLeft > 0 ? `${confirmText} (${secondsLeft})` : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
